import { useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "今日热瓜", href: "#hot" },
  { label: "社区板块", href: "#boards" },
  { label: "正在聊", href: "#discuss" },
  { label: "入口指引", href: "#guide" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={scrollTop}
          className="flex items-center gap-2.5 whitespace-nowrap"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-base text-background-50">
            <i className="ri-water-flash-line"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            吃瓜入口
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#guide"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-bookmark-line"></i>
            收藏本站
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#guide"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-bookmark-line"></i>
              收藏本站
            </a>
          </div>
        </div>
      )}
    </header>
  );
}